import React, { Dispatch } from 'react'

import { IPartyNumberMap } from '../../models/TypeHelper'

import TabInterface from '../Tabs/TabInterface'
import Tab from '../Tabs/Tab'
import { connect } from 'react-redux'
import {
  IReduxAction,
  IReduxState,
  PredictionModel
} from '../../utils/ReduxStore'

import './InsightsWrapper.scss'
import HistogramWrapper from './Histogram/HistogramWrapper'
import Governments from './Governments/Governments'
import PartyResultMap from '../../models/PartyResultMap'
import IconLabel from '../Helpers/IconLabel'
import { debounce } from 'debounce'

export interface IRegionalPollMap {
  [key: string]: IPartyNumberMap
}

interface IDispatchProps {
  generateOutcome: () => void
  generateManyOutcomes: () => void
}

interface IStateProps {
  compareResultKey: string
  outcomes: PartyResultMap[]
  outcomesToGenerate: number
  lastReset: number
  predictionModel: PredictionModel
}

interface IProps extends IDispatchProps, IStateProps {}

interface IState {
  tick: boolean
}

class InsightsWrapper extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props)

    this.state = {
      tick: false
    }

    this.generateMany = this.generateMany.bind(this)
    this.debouncedGenerateMany = debounce(this.generateMany, 2000)
  }

  public componentDidMount(): void {
    if (this.props.outcomes.length === 0) this.generateMany()
  }

  public componentDidUpdate(prevProps: IProps): void {
    if (prevProps.compareResultKey !== this.props.compareResultKey) {
      this.debouncedGenerateMany()
    }
    if (prevProps.predictionModel !== this.props.predictionModel) {
      this.generateMany()
    }
  }

  public debouncedGenerateMany(numTimes = 100): void {
    this.generateMany(numTimes)
  }

  public generateMany(numTimes = 100): void {
    for (let i = 0; i < numTimes; i++) {
      setTimeout((): void => {
        this.props.generateOutcome()
      }, i * 25)
    }
  }

  public render(): JSX.Element {
    return (
      <div className="row mt-3 InsightsWrapper">
        <div className="col">
          <h2 className="mb-0">Insights</h2>
          <p>
            <small className="text-muted">
              Based on <b>{this.props.outcomes.length}</b> simulations
            </small>
          </p>
          <p>
            Ensure that <strong>Randomized swing</strong> is enabled in the
            Settings (there is no variability in the deterministic swing model).
            Then, click the buttons below to generate possible outcomes given
            the input polling values and an assumed margin of polling error of
            &plusmn; 3.0%, 19 times out of 20. For more information, see the{' '}
            <button
              className="About btn btn-sm btn-dark mx-1"
              data-toggle="modal"
              data-target="#AboutModal"
            >
              <i className="fas fa-lg fa-info-circle" />
              <span className="d-none d-sm-inline ml-2">About</span>
            </button>{' '}
            page.
          </p>
          <div className="mb-4">
            <button
              onClick={this.props.generateOutcome}
              className="btn btn-secondary"
              id="xmany"
            >
              <IconLabel icon="fas fa-cog" label="Generate outcome" />
            </button>
            <button
              onClick={(): void => {
                this.generateMany(100)
              }}
              className="btn btn-secondary ml-2"
            >
              <IconLabel icon="fas fa-cogs" label="Generate 100 outcomes" />
            </button>
          </div>
          <hr />
          <TabInterface className="mt-4" defaultTab={'governments'}>
            <Tab key="governments" name="Governments">
              <Governments outcomes={this.props.outcomes} />
            </Tab>
            <Tab key="histogram" name="Seat histogram">
              <HistogramWrapper />
            </Tab>
          </TabInterface>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: IReduxState): IStateProps => ({
  compareResultKey: state.compareResultKey,
  outcomes: state.outcomes,
  outcomesToGenerate: state.outcomesToGenerate,
  lastReset: state.lastReset,
  predictionModel: state.predictionModel
})

const mapDispatchToProps = (
  dispatch: Dispatch<IReduxAction>
): IDispatchProps => ({
  generateOutcome: (): void => {
    dispatch({ type: 'GENERATE_OUTCOME' })
  },
  generateManyOutcomes: (): void => {
    dispatch({ type: 'GENERATE_MANY_OUTCOMES' })
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InsightsWrapper)
